<div *ngIf="isDelta; else vscontent" class="flyout">
  <div
    [ngClass]="{ 'loggedin-feed-active': feedTabLoggedinFlag }"
    [style.top.px]="flyOutPositionHeight"
    class="loggedin-flyout delta flyout-main-container mt-lg-0 border-top-0"
  >
    <div class="container container-wrapper">
      <div
        [style.top.px]="flyOutPositionHeight"
        aria-describedby="account-description"
        class="flyout-content content content-loggedIn"
        tabindex="0"
      >
        <div
          [ngClass]="{ 'new-flyout-container': showNewFlyout }"
          aria-label="Account Information"
          class="loggedin-modal"
        >
          <div class="loggedin-container">
            <div
              [style.top.px]="flyoutFeedHeaderPosition"
              class="d-lg-none feed-header bg-dark fixed-top"
            >
              <div class="text-right">
                <a
                  (click)="close()"
                  class="bg-dark"
                  href="javascript:void(0);"
                  role="button"
                >
                  Close
                </a>
              </div>
            </div>
            <div class="modal-content mt-lg-0 border-top-0">
              <div class="modal-body pl-0 pr-0">
                <span class="sr-only">tab list</span>
                <ngc-accountSummary
                  [isDelta]="isDelta"
                  [resAcctSumContent]="flyoutContent"
                  [staticTrackerAemContent]="staticTrackerAemContent"
                  id="account-description"
                ></ngc-accountSummary>
                <tabset
                  [ngClass]="{ 'today-tab-align': enableTodayTab }"
                  role="tablist"
                >
                  <tab
                    (select)="selectedTabEvent($event)"
                    *ngIf="enableTodayTab"
                    active="true"
                    aria-labelledby="today-tab-link"
                    class="today-tab pl-0 pr-0 h-100"
                    customClass="today-tab-link col"
                    id="today-tab"
                    role="tabpanel"
                  >
                    <ng-template tabHeading>
                      <span class="tabHeading">
                        {{ flyoutContent?.todayLabel }}
                      </span>
                    </ng-template>

                    <ngc-flyout-today
                      [aemErrorMessages]="aemErrorMessages"
                      [bookingHeaderContentLabel]="bookingHeaderContentLabel"
                      [medallionArrayFromContent]="medallionArrayFromContent"
                      [mytripHeaderContentLabel]="mytripHeaderContentLabel"
                      [resTodayTripContent]="flyoutTodayContent"
                      [showNewToday]="showNewToday"
                      aria-labelledby="today-tab"
                      id="today-content-panel"
                      role="tabpanel"
                    ></ngc-flyout-today>
                  </tab>
                  <tab
                    (select)="selectedTabEvent($event)"
                    *ngIf="enableTodayTab || !enableTodayTab"
                    active="true"
                    aria-labelledby="mydelta-tab-link"
                    class="mydelta-tab"
                    customClass="mydelta-tab-link"
                    id="mydelta-tab"
                    role="tabpanel"
                  >
                    <ng-template tabHeading>
                      <span class="tabHeading">
                        {{ flyoutContent?.myFlightLabel }}
                      </span>
                    </ng-template>
                    <ngc-acctactvty
                      *ngIf="
                        !orionFlag || (showStaticTracker && upcomingTracker)
                      "
                      [aemErrorMessages]="aemErrorMessages"
                      [isDelta]="isDelta"
                      [resAcctActivityContent]="flyoutContent"
                      [resAcctSumContent]="flyoutContent"
                      [resAcctSumDetails]="resAcctSumDetails"
                      [showNewFlyout]="showNewFlyout"
                    ></ngc-acctactvty>
                    <div
                      *ngIf="isLoggedIn && orionFlag"
                      class="skymiles__wrapper__overview__container__wrap"
                    >
                      <idp-flyout-tracker
                        [flyoutContent]="flyoutContent"
                        [resAcctSumDetails]="resAcctSumDetails"
                      ></idp-flyout-tracker>
                    </div>
                  </tab>
                  <tab
                    (select)="selectedTabEvent('feed-tab')"
                    *ngIf="
                      (enableTodayTab || !enableTodayTab) &&
                      isDelta &&
                      !orionFlag
                    "
                    aria-labelledby="feed-tab-link"
                    class="feed-tab p-0"
                    customClass="feed-tab-link col"
                    id="feed-tab"
                    role="tabpanel"
                  >
                    <ng-template tabHeading>
                      <div
                        (click)="updateFeedCount()"
                        *ngIf="feedCounterValue > 0"
                        aria-hidden="true"
                        class="flyout-feed-counter"
                      >
                        <div class="flyout-feed-counter-text">
                          {{ feedCounterValue }}
                        </div>
                      </div>
                      <span (click)="updateFeedCount()" class="tabHeading">
                        {{ flyoutContent?.feed }}
                      </span>
                    </ng-template>

                    <ngc-flyout-feed
                      [isLoggedInData]="isloggedInFeed"
                      [isloggedInFeed]="isloggedInFeed"
                      [showNewFlyout]="showNewFlyout"
                      [triggerNewsData]="triggerNewsData"
                      aria-labelledby="feed-tab"
                      id="feed-content-panel"
                      role="tabpanel"
                    ></ngc-flyout-feed>
                  </tab>
                </tabset>
                <!-- BOTTOM STICKY LINKS START-->
                <div class="row no-gutters bottom-sticky-links">
                  <div
                    class="col-sm-3 col-md-3 col-xl-3 col-lg-3 bottom-anchors fadeIn"
                  >
                    <a href="{{ flyoutContent?.dashboardUrl }}">
                      {{ flyoutContent?.dashboardLabel }}
                    </a>
                  </div>
                  <div
                    class="col-sm-2 col-md-3 col-xl-2 col-lg-3 bottom-anchors fadeIn"
                  >
                    <a href="{{ flyoutContent?.profileUrl }}">
                      {{ flyoutContent?.profileLabel }}
                    </a>
                  </div>
                  <div
                    class="col-sm-4 col-md-3 col-xl-4 col-lg-3 bottom-anchors fadeIn"
                  >
                    <a
                      href="{{
                        !orionFlag
                          ? flyoutContent?.mySkyMilesUrl ||
                            flyoustaticTrackerAemContent?.exploreSkymilesLink
                          : flyoutContent?.newMySkyMilesUrl
                      }}"
                    >
                      {{ flyoutContent?.mySkyMilesLabel || 'My SkyMiles' }}
                    </a>
                  </div>
                  <div
                    class="col-sm-3 col-md-3 col-xl-3 col-lg-3 bottom-anchors fadeIn"
                  >
                    <a
                      (click)="logOut()"
                      href="javascript:void(0);"
                      id="flyout-logOut-link"
                      role="button"
                    >
                      {{ flyoutContent?.logoutLabel }}
                    </a>
                  </div>
                </div>
                <!-- BOTTOM STICKY LINKS END-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #vscontent>
  <div class="loggedin-flyout flyout-main-container mt-lg-0 border-top-0">
    <div class="container container-wrapper">
      <div
        [style.top.px]="flyOutPositionHeight"
        aria-describedby="account-description"
        class="flyout-content content content-loggedIn"
        tabindex="0"
      >
        <div class="loggedin-modal">
          <!-- <div  [ngClass]= "getClassNamesVS(resAcctSumDetails?.membershipLevel)" id="tierColor"></div>-->
          <div class="feed-header bg-dark fixed-top">
            <div class="text-right d-lg-none d-md-none d-sm-block">
              <a
                (click)="closeloginFlyout()"
                class="bg-dark va-close-out"
                href="javascript:void(0);"
                role="button"
              >
                Close
              </a>
            </div>
          </div>
          <div class="modal-body">
            <ngc-accountSummary
              [isDelta]="isDelta"
              [resAcctSumContent]="flyoutContent"
              id="account-description"
            ></ngc-accountSummary>
            <span class="sr-only">tab list</span>
            <tabset
              *ngIf="enableVsTodayTab; else onlyMyAccount"
              class="va-tablist"
              role="tablist"
            >
              <tab
                (select)="selectedTabEvent($event, 'today-tab')"
                aria-controls="today-content-panel"
                aria-selected="false"
                class="today-tab pl-0 pr-0 h-100"
                customClass="today-tab-link col"
                id="today-tab"
                role="tab"
              >
                <ng-template tabHeading>
                  <span class="tabHeading">
                    {{ flyoutContent?.todayLabel }}
                  </span>
                </ng-template>
                <!--<a href="javascript:void(0);" class="close-icon-va d-lg-block d-md-block d-sm-none"  (click)="close()"><span class="sr-only">Close</span></a>-->
                <!-- <hr class="separator d-none">-->
                <ngc-flyout-today
                  [aemErrorMessages]="aemErrorMessages"
                  [bookingHeaderContentLabel]="bookingHeaderContentLabel"
                  [medallionArrayFromContent]="medallionArrayFromContent"
                  [mytripHeaderContentLabel]="mytripHeaderContentLabel"
                  [resTodayTripContent]="flyoutTodayContent"
                  aria-labelledby="today-tab"
                  id="today-content-panel"
                  role="tabpanel"
                ></ngc-flyout-today>
              </tab>
              <tab
                (select)="selectedTabEvent($event, 'mydelta-tab')"
                aria-controls="mydelta-content-panel"
                aria-selected="true"
                class="mydelta-tab"
                customClass="mydelta-tab-link"
                id="mydelta-tab"
                role="tab"
              >
                <ng-template tabHeading>
                  <span class="tabHeading">
                    {{ flyoutContent?.myFlightLabel }}
                  </span>
                </ng-template>
                <!--<a href="javascript:void(0);" class="close-icon-va d-lg-none d-md-block d-sm-block"  (click)="close()"><span class="sr-only">Close</span></a>-->
                <!--<hr class="separator d-none">-->
                <ngc-acctactvty
                  [aemErrorMessages]="aemErrorMessages"
                  [isDelta]="isDelta"
                  [resAcctActivityContent]="flyoutContent"
                  [resAcctSumContent]="flyoutContent"
                  [resAcctSumDetails]="resAcctSumDetails"
                  [showNewFlyout]="showNewFlyout"
                ></ngc-acctactvty>
              </tab>
            </tabset>
            <ng-template #onlyMyAccount>
              <ngc-acctactvty
                [aemErrorMessages]="aemErrorMessages"
                [isDelta]="isDelta"
                [resAcctActivityContent]="flyoutContent"
                [resAcctSumContent]="flyoutContent"
                [resAcctSumDetails]="resAcctSumDetails"
                [showNewFlyout]="showNewFlyout"
              ></ngc-acctactvty>
            </ng-template>
            <!-- BOTTOM STICKY LINKS START-->
            <div class="row no-gutters vs-bottom-sticky-links">
              <div
                [ngClass]="{ 'bottom-anchors': flyoutContent?.dashboardLabel }"
                class="col-sm-4 col-md-4 col-xl-4 col-lg-4"
              >
                <a
                  *ngIf="flyoutContent?.dashboardLabel"
                  href="{{ flyoutContent?.dashboardUrl }}"
                >
                  {{ flyoutContent?.dashboardLabel }}
                </a>
              </div>
              <div
                [ngClass]="{ 'bottom-anchors': flyoutContent?.profileLabel }"
                class="col-sm-4 col-md-4 col-xl-4 col-lg-4"
              >
                <a
                  *ngIf="flyoutContent?.profileLabel"
                  href="{{ flyoutContent?.profileUrl }}"
                >
                  {{ flyoutContent?.profileLabel }}
                </a>
              </div>
              <div class="col-sm-4 col-md-4 col-xl-4 col-lg-4">
                <a
                  (click)="logOut()"
                  *ngIf="flyoutContent?.logoutLabel"
                  href="javascript:void(0);"
                >
                  {{ flyoutContent?.logoutLabel }}
                </a>
              </div>
            </div>
            <!-- BOTTOM STICKY LINKS END-->
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
